import type { 
  GetLiveLatestEventsNewSportBetsData,
  GetLiveLatestEventsNewSportBetsResponse,

  GetLiveLatestEventsNewDepositsData,
  GetLiveLatestEventsNewDepositsResponse,

  GetLiveTopEventsTop20EventsWithoutResultData,
  GetLiveTopEventsTop20EventsWithoutResultResponse,

  GetLiveTopEventsTop20EventsWithResultData,
  GetLiveTopEventsTop20EventsWithResultResponse
 } from "@/types/openapi-ts";

import type { AxiosInstance } from "axios";

export function getLiveApiModule(affiliatesApi: AxiosInstance) {
  return {
    // Live Latest Events

    // Get 20 latest sport bets
    getNewSportBets(params: GetLiveLatestEventsNewSportBetsData['query']) {
      return affiliatesApi.get<GetLiveLatestEventsNewSportBetsResponse>(
        '/live/latest-events/new-sport-bets', 
        { params }
      );
    },
    // Get 20 latest deposits
    getNewDeposits(params: GetLiveLatestEventsNewDepositsData['query']) {
      return affiliatesApi.get<GetLiveLatestEventsNewDepositsResponse>(
        '/live/latest-events/new-deposits', 
        { params }
      );
    },

    // Live Top Event
    getTop20EventsWithoutResult(params: GetLiveTopEventsTop20EventsWithoutResultData['query']) {
      return affiliatesApi.get<GetLiveTopEventsTop20EventsWithoutResultResponse>(
        '/live/top-events/top-20-events-without-result', 
        { params }
      );
    },
    getTop20EventsWithResult(params: GetLiveTopEventsTop20EventsWithResultData['query']) {
      return affiliatesApi.get<GetLiveTopEventsTop20EventsWithResultResponse>('/live/top-events/top-20-events-with-result', { params });
    },
  }
}
